import {
  typeComponentBank,
  typeComponentCorporate,
  typeComponentLifeInsurance,
  typeComponentNonBank,
  typeComponentNonLifeInsurance,
  typeComponentSecurity,
} from '../constant'
import { FORMAT_TYPES } from '../highlight'

export const itemHighlightBank = (ratioCode) => {
  switch (ratioCode) {
    case 'NB219':
      return {
        props: { formatType: FORMAT_TYPES.PERCENTAGE },
        scrollElementClass: typeComponentBank.CAPITAL_AND_LEVERAGE,
      }
    case 'FA150':
      return {
        props: { formatType: FORMAT_TYPES.PERCENTAGE },
        scrollElementClass: typeComponentBank.EARNING_QUALITY,
      }
    case 'FA146':
      return {
        props: { formatType: FORMAT_TYPES.PERCENTAGE },
        scrollElementClass: typeComponentBank.LOAN_BOOK_BREAKDOWN,
      }
    case 'RT0059':
      return {
        props: { formatType: FORMAT_TYPES.PERCENTAGE },
        scrollElementClass: typeComponentBank.EARNING_QUALITY,
      }
    case 'RT0277':
      return {
        props: { formatType: FORMAT_TYPES.PERCENTAGE },
        scrollElementClass: typeComponentBank.LIQUIDITY,
      }
    case 'RT0295':
      return {
        props: { formatType: FORMAT_TYPES.PERCENTAGE },
        scrollElementClass: typeComponentBank.QUICK_ASSESSMENT,
      }
    default:
      return { props: {} }
  }
}

export const itemHighlightCorporate = (ratioCode) => {
  switch (ratioCode) {
    case 'RT0020':
      return {
        props: { formatType: FORMAT_TYPES.DECIMAL },
        scrollElementClass: typeComponentCorporate.LIQUIDITY,
      }
    case 'FA159':
      return {
        props: { formatType: FORMAT_TYPES.DECIMAL },
        scrollElementClass: typeComponentCorporate.SOLVENCY,
      }
    case 'RT0059':
      return {
        props: { formatType: FORMAT_TYPES.PERCENTAGE },
        scrollElementClass: typeComponentCorporate.ROA_AND_ROE,
      }
    case 'RT0054':
      return {
        props: { formatType: FORMAT_TYPES.PERCENTAGE },
        scrollElementClass: typeComponentCorporate.PROFITABILITY,
      }
    case 'RT0015':
      return {
        props: { formatType: FORMAT_TYPES.DECIMAL },
        scrollElementClass: typeComponentCorporate.ASSET_MANAGEMENT_EFFICIENCY,
      }
    default:
      return { props: {} }
  }
}

export const itemHighlightSecurity = (ratioCode) => {
  switch (ratioCode) {
    case 'IS20':
      return {
        props: { formatType: FORMAT_TYPES.CURRENCY_EXCHANGE },
        scrollElementClass: typeComponentSecurity.EARNING_BREAKDOWN,
      }
    case 'FA073':
      return {
        props: { formatType: FORMAT_TYPES.PERCENTAGE },
        scrollElementClass: typeComponentSecurity.BUSINESS_POSITION,
      }
    case 'RT0060':
      return {
        props: { formatType: FORMAT_TYPES.PERCENTAGE },
        scrollElementClass: typeComponentSecurity.EARNING_QUALITY,
      }
    case 'FA115':
      return {
        props: { formatType: FORMAT_TYPES.DECIMAL },
        scrollElementClass: typeComponentSecurity.LEVERAGE,
      }
    case 'RT0020':
      return {
        props: { formatType: FORMAT_TYPES.DECIMAL },
        scrollElementClass: typeComponentSecurity.FUNDING_AND_LIQUIDITY,
      }
    default:
      return { props: {} }
  }
}

export const itemHighlightNonBank = (ratioCode) => {
  switch (ratioCode) {
    case 'RT0296':
      return {
        props: { formatType: FORMAT_TYPES.PERCENTAGE },
        scrollElementClass: typeComponentNonBank.DEPOSIT_AND_CREDIT,
      }
    case 'FA150':
      return {
        props: { formatType: FORMAT_TYPES.PERCENTAGE },
        scrollElementClass: typeComponentNonBank.EARNING_QUALITY,
      }
    case 'FA146':
      return {
        props: { formatType: FORMAT_TYPES.PERCENTAGE },
        scrollElementClass: typeComponentNonBank.LOAN_BOOK_BREAKDOWN,
      }
    case 'RT0414':
      return {
        props: { formatType: FORMAT_TYPES.PERCENTAGE },
        scrollElementClass: '',
      }
    case 'RT0059':
      return {
        props: { formatType: FORMAT_TYPES.PERCENTAGE },
        scrollElementClass: typeComponentNonBank.EARNING_QUALITY,
      }
    case 'FA229':
      return {
        props: { formatType: FORMAT_TYPES.PERCENTAGE },
        scrollElementClass: '',
      }
    default:
      return { props: {} }
  }
}

export const itemHighlightLifeInsurance = (ratioCode) => {
  switch (ratioCode) {
    case 'FA268':
      return {
        props: { formatType: FORMAT_TYPES.PERCENTAGE },
        scrollElementClass:
          typeComponentLifeInsurance.INSURANCE_PREMIUM_REVENUE,
      }
    case 'FA200':
      return {
        props: { formatType: FORMAT_TYPES.PERCENTAGE },
        scrollElementClass: '',
      }
    case 'RT2017':
      return {
        props: { formatType: FORMAT_TYPES.PERCENTAGE },
        scrollElementClass: typeComponentLifeInsurance.OPERATIONAL_EFFICIENCY,
      }
    case 'RT0416':
      return {
        props: { formatType: FORMAT_TYPES.PERCENTAGE },
        scrollElementClass: typeComponentLifeInsurance.PROFITABILITY,
      }
    case 'RT2004':
      return {
        props: { formatType: FORMAT_TYPES.PERCENTAGE },
        scrollElementClass: typeComponentLifeInsurance.ROA_AND_ROE,
      }
    case 'RT0019':
      return {
        props: { formatType: FORMAT_TYPES.PERCENTAGE },
        scrollElementClass: typeComponentLifeInsurance.LIQUIDITY,
      }
    default:
      return { props: {} }
  }
}

export const itemHighlightNonLifeInsurance = (ratioCode) => {
  switch (ratioCode) {
    case 'FA268':
      return {
        props: { formatType: FORMAT_TYPES.PERCENTAGE },
        scrollElementClass:
          typeComponentNonLifeInsurance.INSURANCE_PREMIUM_REVENUE,
      }
    case 'FA200':
      return {
        props: { formatType: FORMAT_TYPES.PERCENTAGE },
        scrollElementClass: '',
      }
    case 'RT2017':
      return {
        props: { formatType: FORMAT_TYPES.PERCENTAGE },
        scrollElementClass:
          typeComponentNonLifeInsurance.OPERATIONAL_EFFICIENCY,
      }
    case 'RT0416':
      return {
        props: { formatType: FORMAT_TYPES.PERCENTAGE },
        scrollElementClass: typeComponentNonLifeInsurance.PROFITABILITY,
      }
    case 'RT2004':
      return {
        props: { formatType: FORMAT_TYPES.PERCENTAGE },
        scrollElementClass: typeComponentNonLifeInsurance.ROA_AND_ROE,
      }
    case 'RT0019':
      return {
        props: { formatType: FORMAT_TYPES.PERCENTAGE },
        scrollElementClass: typeComponentNonLifeInsurance.LIQUIDITY,
      }
    default:
      return { props: {} }
  }
}
